import { render } from "./index.vue?vue&type=template&id=80d5bdbc"
import script from "./seventh.js?vue&type=script&lang=js&external"
export * from "./seventh.js?vue&type=script&lang=js&external"

import "./seventh.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__